import SubscribeForm from 'components/Subscribe/SubscribeForm'

type Props = {}

const SubscribePage = (props: Props) => {
    return <SubscribeForm />
}

export default SubscribePage
